import { format, toDate, utcToZonedTime } from "date-fns-tz";

const formatLocalDatetimeString = (
  utcDatetimeString: string,
  pattern = "MMM d, h:mma z",
  timeZone?: string
) => {
  const targetTimeZone = timeZone || getValidTimeZone();
  const date = toDate(utcDatetimeString);
  const zonedDate = utcToZonedTime(date, targetTimeZone);

  return format(zonedDate, pattern, { timeZone: targetTimeZone });
};

function getValidTimeZone() {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    Intl.DateTimeFormat(undefined, { timeZone });
    return timeZone;
  } catch (_) {
    return "Etc/UTC";
  }
}

export default formatLocalDatetimeString;
